var layout_default = {
  "layout": "v3oKC",
  "cell": "oue8G"
};
export {
  layout_default as default
};
//# sourceMappingURL=layout-scss.js.map
